<template>
  <div class="contaniner">
    <div class="CoalModel_box_title">
      <el-page-header @back="getReturn" content="司机详情"></el-page-header>
    </div>
    <el-divider></el-divider>
    <div style="padding: 0 40px">
      <el-row>
        <el-col :span="5">
          <div>姓名：{{ detail.driverName }}</div>
        </el-col>
        <el-col :span="8">
          <div>
            状态：{{ detail.statusName
            }}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div style="padding: 10px 0">
            手机号：<span style="color: #25aff3">{{ detail.driverPhone }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div style="padding: 10px 0" v-if="detail.status==1&&autoRejReason">
            自动审核未通过原因：<span style="color: red">{{
              autoRejReason
            }}</span>
          </div>
        </el-col>
      </el-row>

      <div style="padding: 0 0 10px 0">身份证号：{{ detail.idCard }}</div>
      <!-- <div>添加人：<span style="color: #25aff3">{{detail.driverManagerPhone}}</span></div> -->
    </div>

    <div class="title" style="padding: 0 40px 20px 40px">身份证正反面</div>
    <el-row style="padding: 0 40px">
      <el-col :span="7">
        <el-image v-if="detail.idCardFrontImg" :src="detail.idCardFrontImg" :preview-src-list="srcList">
        </el-image>
      </el-col>
      <el-col :span="7">
        <el-image v-if="detail.idCardBackImg" :src="detail.idCardBackImg" :preview-src-list="srcList">
        </el-image>
      </el-col>
    </el-row>

    <div class="title" style="padding: 0 40px 20px 40px">驾驶证正反面</div>
    <el-row style="padding: 0 40px">
      <el-col :span="7">
        <el-image
          v-if="detail.driveLicenceFrontImg"
          :src="detail.driveLicenceFrontImg"
          :preview-src-list="srcList2"
        >
        </el-image>
      </el-col>
      <el-col :span="7">
        <el-image
          v-if="detail.driveLicenceBackImg"
          :src="detail.driveLicenceBackImg"
          :preview-src-list="srcList2"
        >
        </el-image>
      </el-col>
    </el-row>
    <div style="padding: 10px 40px">
      <span>操作日志:</span>
      <div v-if="activities">
        <el-timeline :reverse="reverse" style="padding: 10px">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp"
          >
            {{ activity.content }}
            <span class="style_mark" @click="handleCheck(activity)" v-if="activity.operationRemark=='修改司机信息'">查看更变历史</span>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div style="text-indent: 2em" v-else>暂无数据</div>
    </div>
    <div v-if="isShow">
      <el-button @click="showRejDialog = true">审核驳回</el-button>
      <el-button @click="adopt" type="primary">审核通过</el-button>
    </div>
    <el-dialog
      :visible="showRejDialog"
      title="提示"
      width="40%"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      :show-close="false"
    >
      <el-form :model="rejectForm">
        <span>请选择驳回原因</span>
        <el-form-item label="">
          <el-radio-group v-model="rejectForm.reason" @change="changeReason" style="margin-top:10px">
            <el-radio label="身份证信息错误"></el-radio>
            <el-radio label="驾驶证信息错误"></el-radio>
            <el-radio label="准驾车型不符"></el-radio>
            <el-radio label="证件信息不清晰"></el-radio>
            <el-radio label="其他">
              其他
              <el-input
                v-model="rejectForm.otherReason"
                size="mini"
                maxlength="10"
                placeholder="请输入原因"
                :disabled="isDisabled"
                clearable
              ></el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeRej">取消</el-button>
        <el-button type="primary" @click="rejection">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更变内容"
      :visible.sync="dialogCheck"
      :before-close="handlecheckClose"
    >
      <div class="dialog_content">
        <div class="dialog_left">
          <div class="list_title">修改前司机信息</div>
          <el-form :model="formModifyBefore" label-width="80px" label-position="left" size="mini" >
            <el-form-item label="姓名：" v-if="formModifyBefore.driverName">
              {{formModifyBefore.driverName}}
            </el-form-item>
            <el-form-item label="身份证号：" v-if="formModifyBefore.idCard">
              {{formModifyBefore.idCard}}
            </el-form-item>
            <el-form-item label="手机号：" v-if="formModifyBefore.driverPhone">
              <div>{{formModifyBefore.driverPhone}}</div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.idCardFrontImg||formModifyBefore.idCardBackImg">
              <div>身份证正反面</div>
              <div class="picture_area">
                <div class="item" v-if="formModifyBefore.idCardFrontImg">
                  <img @click="handlePicture(formModifyBefore.idCardFrontImg)" :src="formModifyBefore.idCardFrontImg" alt="">
                </div>
                <div class="item" v-if="formModifyBefore.idCardBackImg">
                  <img @click="handlePicture(formModifyBefore.idCardBackImg)" :src="formModifyBefore.idCardBackImg" alt="">
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.driveLicenceFrontImg||formModifyBefore.driveLicenceBackImg">
              <div>驾驶证正反面</div>
              <div class="picture_area">
                <div class="item" v-if="formModifyBefore.driveLicenceFrontImg">
                  <img @click="handlePicture(formModifyBefore.driveLicenceFrontImg)" :src="formModifyBefore.driveLicenceFrontImg" alt="">
                </div>
                <div class="item" v-if="formModifyBefore.driveLicenceBackImg">
                  <img @click="handlePicture(formModifyBefore.driveLicenceBackImg)" :src="formModifyBefore.driveLicenceBackImg" alt="">
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog_right">
          <div class="list_title">修改后司机信息</div>
          <el-form :model="formModifyAfter" label-width="80px" label-position="left" size="mini" >
            <el-form-item label="姓名：" :class="formModifyAfter.driverName === formModifyBefore.driverName?'':'difference'" v-if="formModifyBefore.driverName"> 
              {{formModifyAfter.driverName}}
            </el-form-item>
            <el-form-item label="身份证号：" :class="formModifyAfter.idCard === formModifyBefore.idCard?'':'difference'" v-if="formModifyBefore.idCard">
              {{formModifyAfter.idCard}}
            </el-form-item>
            <el-form-item label="手机号：" :class="formModifyAfter.driverPhone === formModifyBefore.driverPhone?'':'difference'" v-if="formModifyBefore.driverPhone">
              <div>{{formModifyAfter.driverPhone}}</div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.idCardFrontImg||formModifyAfter.idCardBackImg">
              <div>身份证正反面</div>
              <div class="picture_area">
                <div class="item" :class="formModifyAfter.idCardFrontImg === formModifyBefore.idCardFrontImg?'':'difference'" v-if="formModifyBefore.idCardFrontImg">
                  <img @click="handlePicture(formModifyAfter.idCardFrontImg)" :src="formModifyAfter.idCardFrontImg" alt="">
                </div>
                <div class="item" :class="formModifyAfter.idCardBackImg === formModifyBefore.idCardBackImg?'':'difference'" v-if="formModifyAfter.idCardBackImg">
                  <img @click="handlePicture(formModifyAfter.idCardBackImg)" :src="formModifyAfter.idCardBackImg" alt="">
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.driveLicenceFrontImg||formModifyAfter.driveLicenceBackImg">
              <div>驾驶证正反面</div>
              <div class="picture_area">
                <div class="item" :class="formModifyAfter.driveLicenceFrontImg === formModifyBefore.driveLicenceFrontImg?'':'difference'" v-if="formModifyBefore.driveLicenceFrontImg">
                  <img @click="handlePicture(formModifyAfter.driveLicenceFrontImg)" :src="formModifyAfter.driveLicenceFrontImg" alt="">
                </div>
                <div class="item" :class="formModifyAfter.driveLicenceBackImg === formModifyBefore.driveLicenceBackImg?'':'difference'" v-if="formModifyAfter.driveLicenceBackImg">
                  <img @click="handlePicture(formModifyAfter.driveLicenceBackImg)" :src="formModifyAfter.driveLicenceBackImg" alt="">
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-dialog
          key="1"
          :visible.sync="dialogPicture"
          width="40%"
          append-to-body
        >
          <span class="show_picture">
            <img :src="showPicture" alt="">
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["driverNo", "isShow"],
  data() {
    return {
      detail: {},
      srcList: [],
      srcList2: [],
      rejectForm: {
        reason: [],
        otherReason: "",
      },
      isDisabled: true,
      showRejDialog: false,
      reverse: false,
      activities: [],
      autoRejReason: "",
      idCardVerify:'',
      dialogCheck: false,
      dialogPicture: false,
      showPicture: '',
      formModifyBefore: {},
      formModifyAfter: {}
    };
  },
  mounted() {
    this.getData();
    this.getLogList();
  },
  computed: {},
  methods: {
    getData() {
      const _t = this;
      const newObj = { driverNo: _t.driverNo };
      _t.$api.DriverModel.driverGet(newObj).then((res) => {
        if (res.code === "0") {
          _t.srcList.push(res.data.idCardFrontImg);
          _t.srcList.push(res.data.idCardBackImg);
          _t.srcList2.push(res.data.driveLicenceFrontImg);
          _t.srcList2.push(res.data.driveLicenceBackImg);
          _t.detail = res.data;
        } else {
          _t.$message({
            message: "查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
    getReturn() {
      this.$emit("detailFun", false);
    },
    changeReason(val) {
      if (!val.length) return;
      this.isDisabled = val.includes("其他") ? false : true;
      if (!val.includes("其他")) {
        this.rejectForm.otherReason = "";
      }
    },
    closeRej(){
      this.showRejDialog = false,
      this.dialogCloseCallback()
    },
    dialogCloseCallback() {
      this.rejectForm.reason = []
      this.rejectForm.otherReason =''
    },
    // 驳回
    rejection() {
      let { reason, otherReason } = this.rejectForm;
      if (!reason.length) {
        this.$message({
          type: "error",
          message: "请选择原因",
          offset: 300,
        });
        return;
      }
      if (reason.includes("其他") && otherReason == "") {
        this.$message({
          type: "error",
          message: "请填写原因",
          offset: 300,
        });
        return;
      }
      let upPassReason = reason.replace("其他", otherReason);
      const newObj = {
        driverNo: this.driverNo,
        upPassReason,
      };
      this.$api.DriverModel.driverUpPass(newObj).then((res) => {
      this.$message({
        type: res.code =='0' ? 'success' : 'error',
        message : res.code == '0' ? '审核驳回成功' : '审核驳回失败'+res.message
      })
      this.getReturn()
      this.showRejDialog =false
      this.dialogCloseCallback()
      });
    },
    // 通过
    adopt() {
      const _t = this;
      _t.$confirm("请仔细检查司机信息, 是否确认通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const newObj = {
            driverNo: _t.driverNo,
          };
          _t.$api.DriverModel.driverPass(newObj).then((res) => {
            if (res.code === "0") {
              _t.getReturn();
              _t.$message({
                type: "success",
                message: "审核成功!",
              });
            } else {
              _t.$message({
                message: "审核失败, " + res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          // _t.$message({
          //   type: 'info',
          //   message: '已取消提交'
          // })
        });
    },
    getLogList() {
      let params = {
        pageNo: 1,
        pageSize: 10,
        operationModule: 8,
        operationType: 2,
      };
      params["searchFieldList[0].fieldName"] = "dataPk";
      params["searchFieldList[0].singleValue"] = this.driverNo;
      this.$api.DriverModel.getLogList(params).then((res) => {
        this.activities = res.data.dtoList;
        // 取操作历史第一条   身份证验真  驾驶证识别失败 身份证驾驶证不符 准驾车型不符
        if (this.activities) {
          let remarkArr = this.activities[0]["operationRemark"].split(",");
          let tempArr = remarkArr.filter((item) => {
            return item !== "身份证验真未通过";
          });
          this.idCardVerify =
            remarkArr[0] === "身份证验真未通过" ? "身份证验真未通过" : "";
          this.autoRejReason =
            remarkArr[0] === "身份证验真未通过"
              ? tempArr.join(",")
              : (remarkArr[0]==='修改成功' ? '' :remarkArr.join(","));
          this.autoRejReason = this.autoRejReason.replace(/\,/g,' ')
        }
        this.activities &&
          this.activities.forEach((item) => {
            let arr= item.operationRemark.split(',')
            let idCardVerify =
            arr[0] === "身份证验真未通过" ? "身份证验真未通过" : "";
            (item.content = `${
              item.operationType !== "修改" ? item.operationType : ""
            }${
              item.operationStaffName
                ? " 操作人：" + item.operationStaffName
                : ""
            }${
              item.operationType == "审核驳回"
                ? "，驳回原因：" +( idCardVerify  ?idCardVerify :item.operationRemark)
                : ""
            }${
              item.operationType == "修改" && item.operationRemark !=='修改成功'
                ? "自动审核未通过，原因：" + item.operationRemark.replace(/\,/g,' ')
                : ""
            }${
              item.operationType == "修改" && item.operationRemark =='修改成功'
                ? "自动审核通过"
                : ""
            }`),
              (item.timestamp = item.operationTime);
          });
      });
    },
    handleCheck(data){
      const beforeList = JSON.parse(data.modifyBeforeJson)
      const afterist = JSON.parse(data.modifyAfterJson)
      for(let i = 0; i< beforeList.length;i++){
        const item = beforeList[i]
        this.formModifyBefore[item.name] = item.value
      }
      for(let i = 0; i< afterist.length;i++){
        const item = afterist[i]
        this.formModifyAfter[item.name] = item.value
      }
      this.dialogCheck = true
    },
    handlecheckClose(){
      this.dialogCheck = false
      this.formModifyBefore = {}
      this.formModifyAfter ={}
    },
    handlePicture(src){
      console.log(12312312)
      this.showPicture = src
      this.dialogPicture = true
    }
  },
};
</script>

<style lang="scss" scoped>
.el-image {
  width: 400px;
  height: 300px;
  margin-right: 20px;
}

.title {
  margin-top: 40px;
}

.el-select {
  margin-right: 30px;
}

.el-table {
  width: 80%;
}

.contaniner {
  padding-bottom: 100px;
}

.el-button {
  margin-left: 40px;
}
.el-radio{
  line-height: 30px;
}


.style_mark{
  color: rgb(64, 158, 255);
  text-decoration: underline;
  cursor: pointer;
}
.dialog_content{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  } 
  .dialog_right{
    flex: 1;
    border-left: #606060 1px solid;
    padding-left: 20px;
  }
  .dialog_left{
    flex: 1;
    padding-left: 20px;
  }
  .list_title{
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;
  }
}
::v-deep .el-form-item__content {
  font-size: 12px;
}
::v-deep .el-form-item__label{
  font-size: 12px;
}
.picture_area{
  display: flex;
  flex-direction: row;
  .item{
    margin-right: 5px;
    cursor: pointer;
  }
  img{
    width: 100px;
    height: 100px;
  }
}
.difference{
  color: red;
  img{
    border:red solid 1px;
  }
}
.show_picture{
  img{
    width: 100%;
  }
}
</style>
